function TestimonialsSection({
  testimonials,
  testimonialsLoading,
  approveTestimonial,
  deleteTestimonial,
  approvedTestimonials,
  approvedTestimonialsLoading,
  deleteApprovedTestimonial,
}) {
  return (
    <section className="testimonials-admin-block">
      <div className="section-header">
        <h2>Pending Testimonials</h2>
        <span className="testimonial-count">{testimonials.length} pending</span>
      </div>

      {testimonialsLoading && <p className="status-text">Loading testimonials...</p>}

      {testimonials.length === 0 && !testimonialsLoading && (
        <p className="status-text">No pending testimonials to review.</p>
      )}

      <div className="testimonials-admin-grid">
        {testimonials.map((testimonial) => (
          <article className="testimonial-admin-card" key={testimonial.id}>
            <div className="testimonial-admin-body">
              <p className="testimonial-text">{testimonial.text}</p>
              <p className="testimonial-author">- {testimonial.customerName}</p>
            </div>
            <div className="testimonial-admin-actions">
              <button
                type="button"
                className="approve-btn"
                onClick={() => approveTestimonial(testimonial.id)}
              >
                Approve
              </button>
              <button
                type="button"
                className="dismiss-btn"
                onClick={() => deleteTestimonial(testimonial.id)}
              >
                Delete
              </button>
            </div>
          </article>
        ))}
      </div>

      <div className="testimonials-approved-section">
        <div className="section-header">
          <h2>Approved Testimonials</h2>
          <span className="testimonial-count">{approvedTestimonials.length} approved</span>
        </div>

        {approvedTestimonialsLoading && <p className="status-text">Loading approved testimonials...</p>}

        {approvedTestimonials.length === 0 && !approvedTestimonialsLoading && (
          <p className="status-text">No approved testimonials found.</p>
        )}

        <div className="testimonials-admin-grid">
          {approvedTestimonials.map((testimonial) => (
            <article className="testimonial-admin-card" key={testimonial.id}>
              <div className="testimonial-admin-body">
                <p className="testimonial-text">{testimonial.text}</p>
                <p className="testimonial-author">- {testimonial.customerName}</p>
              </div>
              <div className="testimonial-admin-actions">
                <button
                  type="button"
                  className="dismiss-btn"
                  onClick={() => deleteApprovedTestimonial(testimonial.id)}
                >
                  Delete
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
